exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".read[data-v-72facbe9] {\n  background-color: #ececec;\n  opacity: 0.4;\n}", ""]);

// exports
